import React, { useEffect, useState, useRef } from "react";
import { Button, Card, Col, Form, Input, Popconfirm, Row, Select, SelectProps, Space, Tooltip, Modal, DatePicker } from "antd";
import { useParams } from "react-router-dom";
import HTTPService from "../../../utils/makerequest";
import { ICompanyData } from "../../../interfaces/ICompanyData";
import { IAuthentication, UserRole } from "../../../interfaces/authentication";
import { StateLoader } from "../../../redux/StateLoader";
import { IPageProps } from "../../../interfaces/page-data";
import MUIDatagrid, { IMUIDataGridColumns } from "../../../AltisComponent/MUIDataGrid";
import { IInventory } from "../../../interfaces/IItemData";
import { useTranslation } from "react-i18next";
import { DeleteOutlined, EditOutlined, EyeOutlined, UnorderedListOutlined, SaveOutlined, CloseOutlined } from "@ant-design/icons";
import moment from "moment";
import { Toast } from 'primereact/toast';
import Dropdown from "../../../AltisComponent/Dropdown";
import { IUser } from "../../../interfaces/IUser";

const AddEditTransfer: React.FunctionComponent<IPageProps> = () => {
    const { transferId } = useParams<{ transferId: string }>();
    const [form] = Form.useForm();
    const isEditMode = transferId && parseInt(transferId) !== 0;

    const [companyData, setCompanyData] = useState<ICompanyData[]>();
    const loader = new StateLoader();
    const userInfo: IAuthentication = loader.loadAuthState();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [transferData, setTransferData] = useState<any>();
    const [selectedItems, setSelectedItems] = useState<any[]>([]);
    const [inventoryData, setInventoryData] = useState<IInventory>();
    const [userData, setUserData] = useState<IUser[]>();
    const { t } = useTranslation();
    const toast = useRef<Toast>(null);

    useEffect(() => {
        fetchData();
        getUserData(userInfo?.companyId);
        if (isEditMode) {
            getTransferById(parseInt(transferId));
        }
    }, [transferId]);

    const fetchData = async () => {
        const result = await HTTPService.GETCompanyNames();
        setCompanyData(result);
    };

    const getUserData = (companyId: number) => {
        HTTPService.GET(`/User/allUserName?companyId=${companyId}`)
            .then((res) => {
                if (!res.data) {
                    return;
                }
                if (res.status === 200) {
                    setUserData(res.data);
                } else {
                    toast.current?.show({
                        severity: 'error',
                        summary: t('errors'),
                        detail: res.error.message,
                        life: 3000
                    });
                }
            })
            .catch((error) => {
                console.error("Error fetching user data:", error);
            });
    };


    const filterOption: SelectProps<any>['filterOption'] = (input, option) => {
        return (option?.children as unknown as string).toLowerCase().includes(input.toLowerCase());
    };

    const columns: IMUIDataGridColumns[] = [
        ...(userInfo.role !== UserRole.Admin
            ? [
                {
                    title: t('Company Name'),
                    key: 'companyName',
                    placeHolder: t('Company Name'),
                    isSorting: true,
                },
            ]
            : []),
        {
            title: t('inventoryName'),
            headerAlign: 'center',
            align: 'left',
            key: 'inventoryName',
            placeHolder: t('inventoryName'),
            width: 250
        },
        {
            title: t('barcode'),
            isSorting: true,
            key: 'customBarcode',
            placeHolder: t('barcode'),
            width: 250
        },
        {
            title: t('item_type'),
            isSorting: true,
            key: 'typeName',
            placeHolder: t('item_type'),
            width: 250
        },
        {
            title: t('item_group'),
            isSorting: true,
            key: 'categoryName',
            placeHolder: t('item_group'),
            width: 250
        },
        {
            title: t('location'),
            isSorting: true,
            key: 'locationName',
            placeHolder: t('actualLocation'),
            width: 250,
            render: (text, record) => (
                <div>
                    <span>{text}</span>
                    {record.locationName !== record.actualLocationName && (
                        <Tooltip title={record.actualLocationName}>
                            <span style={{ color: 'red', marginLeft: 8, cursor: 'pointer' }}>⚠️</span>
                        </Tooltip>
                    )}
                </div>
            ),
        },
        {
            title: t('inventory_status_name'),
            isSorting: true,
            key: 'inventoryStatusName',
            placeHolder: t('inventory_status_name'),
            width: 250
        },
    ];

    const columns1: IMUIDataGridColumns[] = [
        {
            title: t('inventoryName'),
            headerAlign: 'center',
            align: 'center',
            key: 'inventoryName',
            placeHolder: t('inventoryName'),
            width: 485,
            render: (text, record) => record?.inventoryTBL?.inventoryName
        },
        {
            title: t('barcode'),
            isSorting: true,
            key: 'barcode',
            placeHolder: t('barcode'),
            width: 490,
            render: (text, record) => record?.inventoryTBL?.barcode
        },
        {
            title: t('operations'),
            key: 'operations',
            placeHolder: t('Operations'),
            isSorting: true,
            render: (order, record) => (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                    <Space>
                        <Popconfirm
                            title={t('confirm_delete')}
                            onConfirm={() => handleDeleteItem(record.inventoryId)}
                            okText={t('yes')}
                            cancelText={t('no')}
                        >
                            <Tooltip title={t('delete')} placement="top">
                                <Button
                                    size="small"
                                    icon={<DeleteOutlined />}
                                    style={{
                                        display: userInfo.role === UserRole.Personel ? 'none' : 'inline-block',
                                        width: '60px',
                                        borderRadius: '70px'
                                    }}
                                    onClick={(e) => e.stopPropagation()}
                                />
                            </Tooltip>
                        </Popconfirm>
                    </Space>
                </div>
            ),
        }
    ];


    const handleDeleteItem = (inventoryId: number) => {
        const updatedRepeatMaintenanceTBL = transferData?.assetTBL.filter(
            item => item.inventoryId !== inventoryId
        );

        setTransferData({
            ...transferData,
            assetTBL: updatedRepeatMaintenanceTBL
        });

        toast.current?.show({
            severity: 'success',
            summary: t('success'),
            detail: t('inventory_delete'),
            life: 3000
        });
    };


    const registerTransfer = (formData) => {

        if (!transferData?.assetTBL || transferData.assetTBL.length === 0) {
            toast.current?.show({
                severity: 'error',
                summary: t('errors'),
                detail: t('please_select_inventory'),
                life: 3000
            });
            return;
        }

        const companyIdToUse = userInfo?.role === UserRole.AltisAdmin
            ? formData.companyId
            : userInfo?.companyId;

        const startDate = moment(formData.transferStartDate);
        const finishDate = moment(startDate).add(parseInt(formData.transferFinishDate), 'days');

        const inventoryIds = transferData?.assetTBL?.map(item => item.inventoryId) || [];

        // Convert transferManager from user ID to displayName string
        let transferManagerString = '';
        if (typeof formData.transferManager === 'number') {
            const selectedUser = userData?.find(user => user.userId === formData.transferManager);
            transferManagerString = selectedUser?.displayName || '';
        } else if (typeof formData.transferManager === 'string') {
            transferManagerString = formData.transferManager;
        }

        const newTransferData = {
            transferId: isEditMode ? parseInt(transferId) : undefined,
            companyId: companyIdToUse,
            transferName: formData.transferName,
            destination: formData.destination,
            transferManager: transferManagerString,
            transferStartDate: startDate.format(),
            transferFinishDate: finishDate.format(),
            estimatedCompletion: parseInt(formData.transferFinishDate),
            transferDescription: formData.transferDescription,
            inventoryId: inventoryIds
        };


        const endpoint = isEditMode
            ? `/InventoryTransfer/updateTransfer?transferId=${transferId}`
            : '/InventoryTransfer/registerTransfer';

        HTTPService.POST(endpoint, newTransferData)
            .then((res) => {
                if (res.status === 200) {
                    toast.current?.show({
                        severity: 'success',
                        summary: t('success'),
                        detail: isEditMode ? t('transfer_updated') : t('transfer_registered'),
                        life: 3000
                    });
                    window.location.replace("/admin/transfer-management");

                } else if (res.status === 400) {
                    toast.current?.show({
                        severity: 'error',
                        summary: t('errors'),
                        detail: t(res.data),
                        life: 3000
                    });
                }
            })
            .catch((error) => {
                console.error('Save Error:', error);
                toast.current?.show({
                    severity: 'error',
                    summary: t('errors'),
                    detail: t('save_failed'),
                    life: 3000
                });
            });
    };

    const handleCancel = () => {
        window.location.replace("/admin/transfer-management/");
    };

    const showModal = () => {
        setIsModalVisible(true);
        InventoryFilter();
    };

    const InventoryFilter = (e?) => {
        const filters = e?.filters;
        const body = {
            pageSize: e?.pageSize || 10,
            page: e?.page || 1,
            ...filters
        };

        HTTPService.POST(`/Inventory/filters`, body).then((response) => {
            if (response.status === 200 && response.data) {
                setInventoryData(response.data);
            } else {
                toast.current?.show({
                    severity: 'error',
                    summary: t('errors'),
                    detail: response.data,
                    life: 3000
                });
            }
        });
    };

    const handleModalCancel = () => {
        setIsModalVisible(false);
    };

    const handleAddSelectedItems = () => {
        if (!selectedItems || selectedItems.length === 0) {
            toast.current?.show({
                severity: 'warn',
                summary: t('Warning'),
                detail: t('no_items_selected'),
                life: 3000
            });
            return;
        }

        const existingInventoryIds = new Set(
            transferData?.assetTBL?.map(item => item.inventoryId) || []
        );

        const newItems = selectedItems
            .filter(item => !existingInventoryIds.has(item.inventoryId))
            .map(item => ({
                inventoryId: item.inventoryId,
                inventoryTBL: {
                    inventoryName: item.inventoryName,
                    barcode: item.barcode
                }
            }));


        if (newItems.length === 0) {
            toast.current?.show({
                severity: 'warn',
                summary: t('Warning'),
                detail: t('selected_items_already_exist'),
                life: 3000
            });
            return;
        }

        const updatedItems = transferData?.assetTBL
            ? [...transferData.assetTBL, ...newItems]
            : newItems;

        setTransferData({
            ...transferData,
            assetTBL: updatedItems,
            count: updatedItems.length
        });

        setSelectedItems([]);
        toast.current?.show({
            severity: 'success',
            summary: t('success'),
            detail: t('assetAdd'),
            life: 3000
        });
    };

    const handleRowSelection = (selectedRowsData: any[]) => {
        setSelectedItems(selectedRowsData);
    };

    const getTransferById = async (id: number) => {
        try {
            const response = await HTTPService.GET(`/InventoryTransfer/ById?transferId=${id}`);
            if (response.status === 200 && response.data && response.data.length > 0) {
                const transferData = response.data[0].transferTBL;

                form.setFieldsValue({
                    companyId: transferData.companyId,
                    transferName: transferData.transferName,
                    destination: transferData.destination,
                    transferManager: transferData.transferManager,
                    transferDescription: transferData.transferDescription,
                    transferStartDate: moment(transferData.transferStartDate),
                    transferFinishDate: moment(transferData.transferFinishDate)
                });

                const tableData = {
                    ...transferData,
                    assetTBL: response.data.map(item => ({
                        inventoryId: item.inventoryId,
                        inventoryTBL: {
                            inventoryName: item.inventoryTBL.inventoryName,
                            barcode: item.inventoryTBL.barcode
                        }
                    }))
                };

                setTransferData(tableData);
            }
        } catch (error) {
            console.error('Error fetching transfer:', error);
            toast.current?.show({
                severity: 'error',
                summary: t('errors'),
                detail: t('error_fetching_transfer'),
                life: 3000
            });
        }
    };
    return (
        <>
            <Toast ref={toast} />
            <Form
                form={form}
                layout="vertical"
                onFinish={registerTransfer}
                fields={
                    isEditMode ? [
                        {
                            name: ["transferName"],
                            value: transferData?.transferName
                        },
                        {
                            name: ["transferDescription"],
                            value: transferData?.transferDescription
                        },
                        {
                            name: ["transferManager"],
                            value: transferData?.transferManager
                        },
                        {
                            name: ["destination"],
                            value: transferData?.destination
                        },
                        {
                            name: ["transferStartDate"],
                            value: transferData?.transferStartDate ? moment(transferData?.transferStartDate) : undefined
                        },
                        {
                            name: ["transferFinishDate"],
                            value: transferData?.transferFinishDate ? moment(transferData?.transferFinishDate) : undefined
                        }
                    ] : []
                }
            >
                <Card style={{ padding: "50px" }}>
                    <h3>{isEditMode ? t('editTransfer') : t('addTransfer')}</h3>
                    {userInfo?.role === UserRole.AltisAdmin && (
                        <Form.Item
                            name="companyId"
                            label={t('Select company')}
                            rules={[{ required: true, message: t('please_select_a_company') }]}
                        >
                            <Select showSearch placeholder={t('company_name')} style={{ marginBottom: '6px' }} filterOption={filterOption}>
                                {companyData?.map((company) => (
                                    <Select.Option key={company.companyId} value={company.companyId}>
                                        {company.companyName}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    )}

                    {/* <Form.Item
                        label={t('transferName')}
                        name="transferName"
                        rules={[{ required: false, message: t('transferName') }]}
                    >
                        <Input placeholder={t('transferName')} style={{ borderRadius: '5px' }} />
                    </Form.Item> */}

                    <Form.Item
                        label={t('transferDescription')}
                        name="transferDescription"
                        rules={[{ required: true, message: t('transferDescription') }]}
                    >
                        <Input placeholder={t('transferDescription')} style={{ borderRadius: '5px' }} />
                    </Form.Item>


                    <Form.Item
                        label={t('transferManager')}
                        name="transferManager"
                        rules={[{ required: true, message: t('transferManager') }]}
                    >
                        <Dropdown
                            placeholder={t('transferManager')}
                            dataSource={userData}
                            valueKey="userId"
                            labelKey="displayName"
                            allowCustomValue={true}
                            style={{ width: '100%' }}
                            includeEmptyOption={false}
                        />
                    </Form.Item>


                    <Form.Item
                        label={t('destination')}
                        name="destination"
                        rules={[{ required: false, message: t('destination') }]}
                    >
                        <Input placeholder={t('destination')} style={{ borderRadius: '5px' }} />
                    </Form.Item>

                    <Form.Item
                        label={t('transferStartDate')}
                        name="transferStartDate"
                        rules={[{ required: false, message: t('transferStartDate') }]}
                    >
                        <DatePicker
                            showTime
                            format="DD-MM-YYYY HH:mm"
                            placeholder={t('transferStartDate')}
                            style={{ borderRadius: '5px', width: '100%' }} />
                    </Form.Item>

                    {/* <Form.Item
                        label={t('estimatedCompletion')}
                        name="transferFinishDate"
                        rules={[{ 
                            required: false, 
                            pattern: /^[0-9]*$/,
                            min: 1
                        }]}
                    >
                        <Input 
                            type="number"
                            min={1} 
                            placeholder={t('estimatedCompletion')} 
                            style={{ borderRadius: '5px' }} 
                            suffix={t('days')}
                        />
                    </Form.Item> */}

                    <Button
                        onClick={showModal}
                        type="primary"
                        style={{ marginTop: 10, marginRight: 10, borderRadius: '5px' }}
                        icon={<UnorderedListOutlined />}
                    >
                        {t('first_datagrid')}
                    </Button>

                    <Modal
                        title={t('first_datagrid')}
                        visible={isModalVisible}
                        onCancel={handleModalCancel}
                        width={1200}
                        footer={[
                            <Button
                                key="add"
                                type="primary"
                                onClick={() => {
                                    handleAddSelectedItems();
                                    handleModalCancel();
                                }}
                            >
                                {t('add_selected_items')}
                            </Button>
                        ]}
                    >
                        <MUIDatagrid
                            data={inventoryData?.data}
                            columns={columns}
                            enableSelection={true}
                            onSelectionChange={handleRowSelection}
                            onChange={InventoryFilter}
                            defaultPageSize={10}
                            total={inventoryData?.count}
                            filterMode="server"
                        />
                    </Modal>


                    <MUIDatagrid
                        data={transferData?.assetTBL}
                        columns={columns1}
                        onChange={() => { }}
                        total={transferData?.count}
                    />

                    <Form.Item>
                        <Row gutter={[4, 4]} justify="end" align="middle">
                            <Col xs={12} sm={4}>
                                <Button
                                    block
                                    onClick={handleCancel}
                                    type="primary"
                                    style={{
                                        height: 64,
                                        backgroundColor: 'transparent',
                                        color: '#1890ff',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        padding: '0 10px',
                                        border: 'none',
                                        transition: 'all 0.3s ease',
                                        cursor: 'pointer'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'scale(1.05)';
                                        e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
                                        e.currentTarget.style.color = '#40a9ff';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'scale(1)';
                                        e.currentTarget.style.boxShadow = 'none';
                                        e.currentTarget.style.color = '#1890ff';
                                    }}
                                >
                                    <CloseOutlined style={{ fontSize: 20 }} />
                                    <span style={{ fontSize: '12px', marginTop: '8px', textAlign: 'center' }}>
                                        {t('cancel')}
                                    </span>
                                </Button>
                            </Col>
                            <Col xs={12} sm={4}>
                                <Button
                                    block
                                    htmlType="submit"
                                    type="primary"
                                    style={{
                                        height: 64,
                                        backgroundColor: 'transparent',
                                        color: '#1890ff',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        padding: '0 10px',
                                        border: 'none',
                                        transition: 'all 0.3s ease',
                                        cursor: 'pointer'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'scale(1.05)';
                                        e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
                                        e.currentTarget.style.color = '#40a9ff';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'scale(1)';
                                        e.currentTarget.style.boxShadow = 'none';
                                        e.currentTarget.style.color = '#1890ff';
                                    }}
                                >
                                    <SaveOutlined style={{ fontSize: 20 }} />
                                    <span style={{ fontSize: '12px', marginTop: '8px', textAlign: 'center' }}>
                                        {t('save')}
                                    </span>
                                </Button>
                            </Col>
                        </Row>
                    </Form.Item>
                </Card>
            </Form>
        </>
    );
};

export default AddEditTransfer;
